import { account } from "./pages/account"
import { booking } from "./pages/booking"
import { orderedServices } from "./pages/orderedServices"
import { shop } from "./pages/shop"
import { standBooking } from "./pages/standbooking"

export const pages = {
  loading: "Wird geladen ...",
  loginSuccess: {
    title: "Anmeldung erfolgreich",
    content:
      "Sie haben sich erfolgreich bei Ihrem Konto angemeldet. Bitte klicken Sie auf den Button, wenn Sie nicht automatisch weitergeleitet werden.",
    button: "Weiterleiten",
  },
  sidebar: {
    staticContact: {
      title: "Hauptaussteller",
      email: "E-Mail",
      phone: "Telefon",
    },
  },
  account: account,
  standBooking: standBooking,
  booking: booking,
  shop: shop,
  orderedServices: orderedServices,
}
